import { useState, createContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const OverridesContext = /*#__PURE__*/createContext({
  setOverride: () => null
});
const OverridesProvider = _ref => {
  let {
    children
  } = _ref;
  const [locale, setLocale] = useState();
  const [betaFeatures, setBetaFeatures] = useState();
  const setter = (key, value) => {
    switch (key) {
      case "betaFeatures":
        setBetaFeatures(value);
        break;
      case "locale":
        setLocale(value);
        break;
      default:
        throw new Error(`Missing case for overriding ${key}!`);
    }
  };
  return /*#__PURE__*/jsx(OverridesContext.Provider, {
    value: {
      locale,
      betaFeatures,
      setOverride: setter
    },
    children: children
  });
};

export { OverridesContext, OverridesProvider };
//# sourceMappingURL=overrides.js.map
